<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="12" md="8">
        <v-card>
          <BaseRichTextEditor :content="project.richtext" :is-read-only="false">
            <template v-slot:heading="{ content }">
              <v-toolbar flat>
                <v-toolbar-title>
                  <v-icon left>edit</v-icon>
                  {{ project.forgeID }}
                </v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    text
                    class="mx-1"
                    :to="{ name: 'ProjectSummaryView', params: { id: parseInt(id) } }"
                  >
                    <v-icon left>fas fa-caret-left</v-icon>
                    Back
                  </v-btn>
                  <v-btn class="mx-1" color="success" @click="save(content)" text>
                    <v-icon left>fas fa-save</v-icon>
                    Save
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
            </template>
          </BaseRichTextEditor>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseRichTextEditor from "../../components/Base/BaseRichTextEditor";
import Project from "../../models/Project";
export default {
  name: "ProjectSummaryEditView",
  components: { BaseRichTextEditor },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    project() {
      return Project.find(parseInt(this.id))
    }
  },
  methods: {
    save(content) {
      Project
        .$put(this.id, { richtext: content })
        .then(() =>
          this.$router.push({
            name: "ProjectSummaryView",
            params: { id: parseInt(this.id) }
          })
        );
    }
  }
}
</script>
